/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Synthetic_Voice_LabelInputs */



/**
* | output |
* | --- |
* | "Synthetic Voice" |
*
* @param {Paste_Attributes_Synthetic_Voice_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_synthetic_voice_label = /** @type {((inputs?: Paste_Attributes_Synthetic_Voice_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Synthetic_Voice_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix synthetique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synthetische Stimme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voce sintetica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синтетический голос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Voz sintética")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合成语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合成音声")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृत्रिम आवाज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voz Sintética")
	return /** @type {LocalizedString} */ ("Synthetic Voice")
});